import {createFileRoute} from "@tanstack/react-router";
import {z as zod} from "zod";
import {robustJsonResultClientFetch} from "@vesta/error-handling-remix/fetches/robustJsonResultClientFetch";
import {uniqueUuid} from "@vesta/unique/unique";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {storageDatabaseValidator, type StorageDatabase} from "~/domainModels/adminModels/storageDatabase";

export const STORAGE_DATABASES_QUERY_KEY = uniqueUuid`c4f2d3e5-8a9b-4c0d-b2e3-f4a5b6c7d8e9`;

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/storage-db")({
    loader: async ({context}) => {
        const storageDatabases = await context.queryClient.ensureQueryData<Array<StorageDatabase>>({
            queryKey: [STORAGE_DATABASES_QUERY_KEY],
            queryFn: async () => {
                const result = await robustJsonResultClientFetch(
                    `${context.intellsysBaseUrl}/sub-system/pluto/admin/storage-databases/get`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${context.authenticationStatus.accessToken}`,
                        },
                        body: JSON.stringify({limit: 1000, offset: 0}),
                    },
                    zod.array(storageDatabaseValidator),
                );
                if (result.success !== true) {
                    throw new Error("Failed to fetch storage databases");
                }
                return result.data;
            },
        });

        return {
            storageDatabases,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
